import React, { createContext, useContext, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const GlobalAlertContext = createContext();
export const useGlobalAlert = () => useContext(GlobalAlertContext);

export const GlobalAlertProvider = ({ children }) => {
  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    type: "info", // success | error | warning | info
    confirmLabel: "Yes",
    cancelLabel: "No",
    onConfirm: null,
    onCancel: null,
    showConfirm: true,
    showCancel: true,
  });

  const showAlert = (options) => {
    setAlertData({
      show: true,
      title: options.title || "Alert",
      message: options.message || "",
      type: options.type || "info",
      confirmLabel: options.confirmLabel || "Yes",
      cancelLabel: options.cancelLabel || "No",
      onConfirm: options.onConfirm || null,
      onCancel: options.onCancel || null,
      showConfirm: options.showConfirm !== false, // default true
      showCancel: options.showCancel !== false,   // default true
    });
  };

  const handleClose = () => setAlertData((prev) => ({ ...prev, show: false }));

  const handleConfirm = () => {
    if (alertData.onConfirm) alertData.onConfirm();
    handleClose();
  };

  const handleCancel = () => {
    if (alertData.onCancel) alertData.onCancel();
    handleClose();
  };

  const typeColors = {
    success: "#198754",
    error: "#dc3545",
    warning: "#ffc107",
    info: "#0dcaf0",
  };

  return (
    <GlobalAlertContext.Provider value={{ showAlert }}>
      {children}

      <Modal show={alertData.show} onHide={handleCancel} centered size="sm"
       backdrop="static"
       keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{
            background: typeColors[alertData.type],
            color: "white",
            padding: "8px 15px",
          }}
        >
          <Modal.Title style={{ fontSize: "1rem", fontWeight: 600 }}>
            {alertData.title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "15px", fontSize: "0.9rem" }}>
          {alertData.message}
        </Modal.Body>

        {(alertData.showConfirm || alertData.showCancel) && (
          <Modal.Footer className="d-flex justify-content-center gap-2 py-2">
            {alertData.showCancel && (
              <Button
                variant="secondary"
                size="sm"
                onClick={handleCancel}
                style={{ minWidth: "70px" }}
              >
                {alertData.cancelLabel}
              </Button>
            )}
            {alertData.showConfirm && (
              <Button
                variant={
                  alertData.type === "success"
                    ? "success"
                    : alertData.type === "error"
                    ? "danger"
                    : alertData.type === "warning"
                    ? "warning"
                    : "info"
                }
                size="sm"
                onClick={handleConfirm}
                style={{ minWidth: "70px", color: "white" }}
              >
                {alertData.confirmLabel}
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </GlobalAlertContext.Provider>
  );
};
